// src/antifraud.ts
const LS_KEY = 'poulet_leader_session';
let leader = false;
const tabId = crypto.randomUUID();
let peerIds = new Set<string>();
let bc: BroadcastChannel | null = null;
let presenceActive = false;

export const becomeLeaderIfFree = (sessionId: string): boolean => {
    const current = localStorage.getItem(LS_KEY);
    if (!current) {
        localStorage.setItem(LS_KEY, sessionId);
        leader = true;
        return true;
    }
    leader = current === sessionId;
    return leader;
};

export const relinquishLeadership = (sessionId: string) => {
    const current = localStorage.getItem(LS_KEY);
    if (current === sessionId) {
        localStorage.removeItem(LS_KEY);
    }
    leader = false;
};

export const isLeader = () => leader;

export const handleStorageLeadership = (sessionId: string, onChange: (isLeader: boolean)=>void) => {
    const listener = (e: StorageEvent) => {
        if (e.key !== LS_KEY) return;
        const now = localStorage.getItem(LS_KEY);
        const newLeader = now === sessionId || !now;
        if (!now) { // try claim
            localStorage.setItem(LS_KEY, sessionId);
            onChange(true);
            leader = true;
        } else {
            leader = now === sessionId;
            onChange(leader);
        }
    };
    window.addEventListener('storage', listener);
    return () => window.removeEventListener('storage', listener);
};

export const fingerprintLite = () => ({
    ua: navigator.userAgent,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'UTC',
    dpr: window.devicePixelRatio || 1,
});

export const getTabId = () => tabId;

export const getPeerCount = () => {
    if (!presenceActive) return 1;
    return 1 + peerIds.size;
};

export const startPresence = () => {
    if (presenceActive) return () => {};
    if (typeof BroadcastChannel === 'undefined') return () => {};
    bc = new BroadcastChannel('poulet_metrics');
    const onMessage = (event: MessageEvent) => {
        const msg = event.data;
        if (!msg || msg.tabId === tabId) return;
        if (msg.type === 'hello') {
            peerIds.add(msg.tabId);
            bc?.postMessage({ type: 'hello', tabId });
        } else if (msg.type === 'bye') {
            peerIds.delete(msg.tabId);
        }
    };
    bc.addEventListener('message', onMessage);
    bc.postMessage({ type: 'hello', tabId });
    const onHide = () => bc?.postMessage({ type: 'bye', tabId });
    window.addEventListener('pagehide', onHide);
    presenceActive = true;
    return () => {
        presenceActive = false;
        window.removeEventListener('pagehide', onHide);
        bc?.removeEventListener('message', onMessage);
        bc?.close();
        bc = null;
        peerIds = new Set<string>();
    };
};
